(() => {
  const config = document.querySelector('[data-optional-tools]')?.dataset;
  if (!config) return;
  const loaded = new Map();
  const resource = (url, style = false) => {
    if (!url) return Promise.resolve();
    if (loaded.has(url)) return loaded.get(url);
    const pending = new Promise((resolve, reject) => {
      const el = document.createElement(style ? 'link' : 'script');
      if (style) { el.rel = 'stylesheet'; el.href = url; } else { el.src = url; el.async = true; }
      el.onload = resolve;
      el.onerror = () => { el.remove(); loaded.delete(url); reject(new Error('Tool could not load')); };
      document.head.appendChild(el);
    });
    loaded.set(url, pending); return pending;
  };
  const instances = { visual: () => window.murallsVisualSearch, finder: () => window.murallsWallpaperFinder };
  const load = async (kind) => {
    await Promise.all([resource(config.results), kind === 'finder' ? resource(config.finderCss, true) : Promise.resolve()]);
    await resource(kind === 'finder' ? config.finder : config.visual);
    return instances[kind]();
  };
  let lastRequest = 0;
  const open = async (kind, button) => {
    const request = ++lastRequest;
    button?.setAttribute('aria-busy', 'true');
    try {
      const modal = await load(kind);
      if (request === lastRequest && modal) modal.open(button);
    } catch (_) {
      let status = document.getElementById('MurallsToolStatus');
      if (!status) { status = document.createElement('p'); status.id = 'MurallsToolStatus'; status.setAttribute('role', 'status'); status.className = 'muralls-tool-status'; document.body.appendChild(status); }
      status.textContent = 'Unable to load this tool. Please try again.';
      setTimeout(() => status.remove(), 5000);
    } finally { button?.removeAttribute('aria-busy'); }
  };
  window.MurallsTools = { load, open };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-visual-search-open], [data-wallpaper-finder-open]');
    if (!button || button.closest('[data-ai-finder-launch-form], [data-ai-finder-example], [data-ai-finder-room-open]')) return;
    const kind = button.hasAttribute('data-wallpaper-finder-open') ? 'finder' : 'visual';
    if (instances[kind]()) return;
    event.preventDefault();
    open(kind, button);
  }, true);
})();
